import React from 'react';
import './DBLoader.css';

const DBLoader = () => {
    return (
      <div className='flex items-center justify-center w-full h-[80vh]'>
        <div className='loader'></div>
      </div>
    );
};

export default DBLoader;
